module.exports = __webpack_public_path__ + "img/henkel-logo-standalone-svg.e0ccd785.svg";